import { useEffect, useState } from "react";

const getCssSafeArea = (variable: string) => {
  if (typeof window === "undefined") return 0;
  const raw = getComputedStyle(document.documentElement).getPropertyValue(variable);
  const numeric = parseFloat(raw || "0");
  return Number.isFinite(numeric) ? numeric : 0;
};

const computeUsableHeight = () => {
  if (typeof window === "undefined") return 0;
  const safeTop = getCssSafeArea("--ion-safe-area-top") || getCssSafeArea("safe-area-inset-top");
  const safeBottom =
    getCssSafeArea("--ion-safe-area-bottom") || getCssSafeArea("safe-area-inset-bottom");
  return window.innerHeight - safeTop - safeBottom;
};

export function useViewportHeight() {
  const [height, setHeight] = useState<number>(computeUsableHeight());

  useEffect(() => {
    const handleResize = () => setHeight(computeUsableHeight());
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return height;
}
